import { AnyObject } from '@triare/auth-redux';
import { DefaultFetchError,
  FetchCreate,
  FetchDelete,
  FetchGet,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate,
  useFetchDelete,
  useFetchGet,
  useFetchGetId,
  useFetchUpdate } from '../fetch';
import { CommentData } from './comments';

export interface SEOResponse {
  id: string;
  isActive: boolean;
  key: string;
  name: string;
  title: string;
  description: string;
  keywords: string;
  data: AnyObject;
  createdAt: string;
  updateAt: string;
}

export enum SEOOrderColumn {
  ID = 'id',
  KEY = 'key',
  NAME = 'name',
  TITLE = 'title',
  DESCRIPTION = 'description',
  KEYWORDS = 'keywords',
  CREATED = 'createdAt',
  UPDATED = 'updatedAt',
}

export interface SEOGetParams extends PagingParams {
  orderByColumn?: SEOOrderColumn;
}

export const useSEOGet = (): FetchGet<
  PagingDataResponse<SEOResponse>,
  SEOGetParams
> => useFetchGet(
  'admin/seo',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

// export const useSEOForSelectGet = (): FetchGet<
//   Pick<SEOShort, 'id'>[],
//   SEOGetParams
// > => useFetchGet(
//   'seo/for-select',
//   {
//     autoStart: false,
//     startStateLoading: false,
//   },
// );

export interface SEOById extends SEOResponse {
  comments: CommentData[];
}

export const useSEOGetById = (seoId?: string): FetchGet<
  SEOById
> => useFetchGetId(
  'admin/seo',
  seoId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export type SEOCreateResponse = SEOResponse
export type SEOCreateData = Omit<SEOResponse, 'id' | 'updateAt' | 'createdAt'>

export const useSEOCreate = (): FetchCreate<
  SEOCreateResponse,
  DefaultFetchError,
  SEOCreateData
> => useFetchCreate(
  'admin/seo',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export type SEOUpdateResponse = SEOCreateResponse;

export interface SEOUpdateData extends Partial<SEOCreateData> {
  id?: string;
}

export const useSEOUpdate = (seoId?: string): FetchUpdate<
  SEOUpdateResponse,
  DefaultFetchError,
  SEOUpdateData
> => useFetchUpdate(
  'admin/seo',
  seoId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export const useSEODelete = (seoId?: string): FetchDelete => useFetchDelete(
  'admin/seo',
  seoId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export default {
  useSEOGet,
  useSEOGetById,
  useSEOCreate,
  useSEOUpdate,
  useSEODelete,
};
